'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _livePresence = require('./live-presence.service');

var _livePresence2 = _interopRequireDefault(_livePresence);

var _livePresenceSharepoint = require('./live-presence-sharepoint.constants');

var _livePresenceSharepoint2 = _interopRequireDefault(_livePresenceSharepoint);

var _livePresenceSitecore = require('./live-presence-sitecore.constants');

var _livePresenceSitecore2 = _interopRequireDefault(_livePresenceSitecore);

var _cbChat = require('./cb-chat.directive');

var _cbChat2 = _interopRequireDefault(_cbChat);

var _chat = require('./chat.controller');

var _chat2 = _interopRequireDefault(_chat);

var _cbChatExtraInfo = require('./cb-chat-extra-info.directive');

var _cbChatExtraInfo2 = _interopRequireDefault(_cbChatExtraInfo);

var _chatExtraInfo = require('./chat-extra-info.controller');

var _chatExtraInfo2 = _interopRequireDefault(_chatExtraInfo);

var _cbChatForm = require('./cb-chat-form.directive');

var _cbChatForm2 = _interopRequireDefault(_cbChatForm);

var _chatForm = require('./chat-form.controller');

var _chatForm2 = _interopRequireDefault(_chatForm);

var _cbChatLines = require('./cb-chat-lines.directive');

var _cbChatLines2 = _interopRequireDefault(_cbChatLines);

var _chatLines = require('./chat-lines.controller');

var _chatLines2 = _interopRequireDefault(_chatLines);

var _index = require('./../../core/api/index');

var _index2 = _interopRequireDefault(_index);

var _cbChatInput = require('./cb-chat-input.directive');

var _cbChatInput2 = _interopRequireDefault(_cbChatInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.chat', [_index2.default.name]).constant('livePresenceSharePointConstants', _livePresenceSharepoint2.default).constant('livePresenceSitecoreConstants', _livePresenceSitecore2.default).service('livePresenceService', _livePresence2.default).controller('chatController', _chat2.default).controller('chatExtraInfoController', _chatExtraInfo2.default).controller('chatFormController', _chatForm2.default).controller('chatLinesController', _chatLines2.default).directive('cbChatExtraInfo', _cbChatExtraInfo2.default).directive('cbChat', _cbChat2.default).directive('cbChatForm', _cbChatForm2.default).directive('cbChatLines', _cbChatLines2.default).directive('cbChatInput', _cbChatInput2.default);

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/index.js
// module id = 872
// module chunks = 0